import { motion } from "framer-motion";
import { FileText, Download, Check } from "lucide-react";
import { Reveal } from "./Reveal";

const INCLUYE = [
  "Ficha del viaje: ruta, fechas, pasajeros, vehículo y hospedaje",
  "Tramos con kilómetros y tiempo de manejo",
  "Presupuesto estimado: combustible, peajes, hospedaje y comidas",
  "Total del viaje y costo por persona",
  "Documentación y requisitos para cruzar la frontera",
  "Trámites migratorios con fechas y enlaces útiles",
];

const Page = ({ src, alt, className, delay, rotate }) => (
  <motion.img src={src} alt={alt} loading="lazy"
    initial={{ opacity: 0, y: 60, rotate: 0 }} whileInView={{ opacity: 1, y: 0, rotate }} whileHover={{ rotate: 0, scale: 1.03 }} viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
    className={`absolute w-[62%] rounded-lg bg-white shadow-[0_40px_80px_-30px_rgba(0,0,0,0.6)] ${className}`} />
);

export const ProposalExample = () => (
  <div data-testid="proposal-example" className="mt-24 grid items-center gap-12 lg:grid-cols-12">
    <div className="relative order-2 h-[360px] sm:h-[560px] lg:order-1 lg:col-span-6">
      <Page src="/img/ejemplo-p2.png" alt="Ejemplo de propuesta, página 2" delay={0.15} rotate={5} className="right-0 top-10" />
      <Page src="/img/ejemplo-p1.png" alt="Ejemplo de propuesta de viaje Asunción a Guarujá, página 1" delay={0} rotate={-4} className="left-0 top-0 z-10" />
    </div>
    <Reveal className="order-1 lg:order-2 lg:col-span-6">
      <span className="inline-flex items-center gap-2 rounded-full bg-sol/15 px-4 py-1.5 text-xs font-bold text-sol"><FileText className="h-4 w-4" /> Ejemplo real</span>
      <h3 className="mt-6 font-display text-3xl font-extrabold leading-tight sm:text-5xl">Esto es lo que <span className="font-serif-i font-normal text-sol">te llega por email.</span></h3>
      <p className="mt-5 text-base leading-relaxed text-arena/85 md:text-lg">
        Una propuesta de viaje en PDF, lista para usar. Este ejemplo es un viaje en auto de Asunción a Guarujá para 2 adultos y 2 niños, 7 días.
      </p>
      <ul className="mt-8 space-y-3">
        {INCLUYE.map((t) => <li key={t} className="flex gap-3 text-base text-arena/90"><Check className="mt-1 h-4 w-4 shrink-0 text-sol" />{t}</li>)}
      </ul>
      <a data-testid="proposal-example-pdf" href="/docs/ejemplo-viaje.pdf" target="_blank" rel="noopener noreferrer"
        className="mt-10 inline-flex items-center gap-2 rounded-full bg-sol px-7 py-4 font-bold text-mar transition-transform duration-300 hover:-translate-y-1">
        <Download className="h-5 w-5" /> Ver el ejemplo completo (PDF)
      </a>
    </Reveal>
  </div>
);
